import React, { useEffect, useState } from "react";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { startCase } from "lodash";

const Turnover = () => {
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [data, setData] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [detail, showDetail] = useState({});
  const handleCloseVerify = () => {
    showDetail({ status: false });
  };
  const [filter, setFilter] = useState({
    status: "active",
    page: 1,
    limit: 100,
  });

  const getData = async (obj = filter, type) => {
    setLoader(true);
    const { status, data } = await apiGet(apiPath.getTurnover, obj);
    if (status == 200) {
      if (data?.success) {
        setData(data?.results?.data);
        setLoader(false);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [filter?.status]);

  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div>
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-vouReport mc-default-header am-navbar am-navbar-light"
          >
            <div className="am-navbar-left" role="button">
              <span
                onClick={() => navigate(-1)}
                className="am-navbar-left-content"
              >
                <span className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">Turnover</div>
            <div className="am-navbar-right">
              <div className="to-record">
                <a href="/m/withdrawReport">
                  <span className="more-icon withdraw am-navbar-title">
                    <svg className="am-icon am-icon-withdraw_record_c986adfb am-icon-md">
                      <use xlinkHref="#withdraw_record_c986adfb" />
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        <div className="am-tabs am-tabs-top">
          <div className="mc-tab-container" id="mc-tab-container">
            <div
              onClick={() => {
                setData([]);
                setFilter((prev) => {
                  return { ...prev, status: "active" };
                });
              }}
              className={`${
                filter?.status == "active" ? "tab-active" : ""
              }  mc-tab-item`}
            >
              <span>Active</span>
            </div>

            <div
              onClick={() => {
                setData([]);
                setFilter((prev) => {
                  return { ...prev, status: "completed" };
                });
              }}
              className={`${
                filter?.status == "completed" ? "tab-active" : ""
              }  mc-tab-item`}
            >
              <span>Completed</span>
            </div>
          </div>
          <div className="am-tabs-content am-tabs-content-no-animated">
            <div
              role="tabpanel"
              aria-hidden="false"
              className="am-tabs-tabpane am-tabs-tabpane-active"
            >
              <div className="mc-trans-record-container voucher">
                <div className="deposit-record-root">
                  <div className="list-wrapper">
                    <ul className="scroll-inner-container">
                      {data?.length > 0 ? (
                        data?.map((res) => {
                          var ratio = Number(
                            (res?.usedAmount / res?.originalAmount) * 100
                          ).toFixed(2);
                          return (
                            <li>
                              <div className="records-root other vou vou-record-item">
                                <div className="am-card">
                                  <div className="am-card-body">
                                    <div className="card-header-wrapper">
                                      <div className="card-header">
                                        <div className="card-header-span">
                                          {res?.isBonusTurnover
                                            ? "Bonus"
                                            : "Normal"}{" "}
                                        </div>
                                        <div
                                          className="time"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {moment(res?.insertDate).format(
                                            "YYYY-MM-DD hh:mm:ss"
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="card-body">
                                      {/* <p className="clearfix deposit-id">
                                        Deposit ref# : {res?.TransactionId}
                                        <svg className="am-icon am-icon-copy_c85522c1 am-icon-md">
                                          <use xlinkHref="#copy_c85522c1" />
                                        </svg>
                                      </p> */}

                                      <p className="clearfix">
                                        Used time :{" "}
                                        {res?.usedAmount > 0 &&
                                        res?.usedAmount !=
                                          Number(res?.originalAmount)
                                          ? Number(res?.usedAmount).toFixed(2)
                                          : ""}
                                      </p>
                                      <p className="clearfix">
                                        Original Amount :{" "}
                                        {Number(res?.originalAmount).toFixed(2)}
                                      </p>
                                      <p className="clearfix">
                                        Status :{startCase(res.status)}
                                      </p>
                                    </div>
                                    {/* <div className="card-footer">
                                      <ul>
                                        <li>
                                          <p>Request</p>
                                          <p className="requestedAmount">
                                            {formatWithCommas(res?.amount)}
                                          </p>
                                        </li>
                                        <li>
                                          <p>
                                            Received
                                            amount
                                          
                                          </p>
                                          <p>
                                            {formatWithCommas(
                                              res?.amount +
                                                (res?.bonus > 0
                                                  ? res?.bonus
                                                  : 0)
                                            )}
                                          </p>
                                        </li>
                                        <li>
                                          <p>Status</p>
                                          <p
                                            className={`${
                                              res?.status == "completed"
                                                ? "col2"
                                                : res?.status == "declined"
                                                ? "col3"
                                                : "col5"
                                            }`}
                                          >
                                            {res?.transferedProcess == "process"
                                              ? "Processing"
                                              : res?.status == "completed"
                                              ? "Approve"
                                              : res?.transferedProcess ==
                                                "requested"
                                              ? "Requested"
                                              : "Decline"}
                                          </p>
                                        </li>
                                      </ul>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                            </li>
                          );
                        })
                      ) : (
                        <div
                          className="nodata-container"
                          style={{ height: "607.609px" }}
                        >
                          <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                            <use xlinkHref="#nodata_f4c19c2d" />
                          </svg>
                          <p className>No data</p>
                        </div>
                      )}
                    </ul>
                    <div className="pullup-wrapper" />
                  </div>
                </div>
              </div>
            </div>
            <div
              role="tabpanel"
              aria-hidden="true"
              className="am-tabs-tabpane am-tabs-tabpane-inactive"
            />
            <div
              role="tabpanel"
              aria-hidden="true"
              className="am-tabs-tabpane am-tabs-tabpane-inactive"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Turnover;
